import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-utensilios',
  templateUrl: './utensilios.component.html',
  styleUrls: ['./utensilios.component.css']
})
export class utensiliosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
